import { render, staticRenderFns } from "./ListLottoPrevious.vue?vue&type=template&id=51abf90b&"
import script from "./ListLottoPrevious.vue?vue&type=script&lang=js&"
export * from "./ListLottoPrevious.vue?vue&type=script&lang=js&"
import style0 from "./ListLottoPrevious.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports